import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0049',
    ecrans: [
        '00-2',
        '01-2'
    ]
});
